export default {
  // CORE
  FinancialSnapshot: require('./file-text-3x.png'),
  spendingAnalysis: require('./search-3x.png'),
  financialGoals: require('./target-3x.png'),
  cashFlow: require('./repeat-3x.png'),
  keyInsight: require('./lightbulb-3x.png'),
  recommendation: require('./clipboard-check-3x.png'),
  financialPlan: require('./calendar-check-2-3x.png'),
  scenarioPlanning: require('./file-question-mark-3x.png'),
  savvy: require('./savvy.png'),
  advisor: require('./users-3x.png'),
  investWithUs: require('./InvestWithUs.png'),
  profile: require('./user-3x.png'),
  financialsupport: require('./graduation-cap-3x.png'),
  'recommendation&Planning': require('./newspaper-3x.png'),
  stayintouch: require('./message-square-more-3x.png'),

  // Old
  finacialReviewLogo: require('./Finacialreview.png'),
  recommendationGreen: require('./recommendationGreen.png'),
  thumbsUp: require('./thumbsUp.png'),
  insights: require('./insights.png'),
  tips: require('./tips.png'),
  cross: require('./cross.png'),
  arrow: require('./arrow.png'),
  profile2: require('./profile2.png'),
  changePassword: require('./changePassword.png'),
  faq: require('./faq.png'),
  aboutUs: require('./aboutUs.png'),
  privacyPolicy: require('./privacyPolicy.png'),
  TNC: require('./T&C.png'),
  help: require('./help.png'),
  logout: require('./logout.png'),
  arrowRight: require('./arrowRight.png'),
  notification: require('./notification.png'),
  myplan: require('./myPlan.png'),
  paymentMethod: require('./paymentMethod.png'),
  home: require('./home.png'),
  setting: require('./setting.png'),
  advisor1: require('./advisor1.png'),
  advisorDummy: require('./AdvisorDummy.png'),
  zillennialLogo: require('./zillennialLogo.png'),
  emailLogo: require('./emailLogo.png'),
  enterSubject: require('./enterSubject.png'),
  description: require('./description.png'),
  ArrowNext: require('./ArrowNext.png'),
  SavvyChatOpen: require('./savvyChatOpen.png'),
  TZALogo: require('./TZALogo.png'),
  sendIcon: require('./sendIcon.png'),
  emojiIcon: require('./emojiIcon.png'),
  eyeOff: require('./eyeOff.png'),
  eyeOn: require('./eyeOn.png'),
  message: require('./message.png'),
  password: require('./password.png'),
  ArrowBack: require('./ArrowBack.png'),
  otp: require('./otp.png'),
  money: require('./money.png'),
  SignOut: require('./SignOut.png'),
  AdvisorGender: require('./AdvisorGender.png'),
  AdvisorReligion: require('./AdvisorReligion.png'),
  AdvisorLocation: require('./AdvisorLocation.png'),
  AdvisorMobile: require('./AdvisorMobile.png'),
  AdvisorEducation: require('./AdvisorEducation.png'),
  AdvisorExperties: require('./AdvisorExperties.png'),
  AdvisorCertificates: require('./AdvisorCertificates.png'),
  AdvisorPortal: require('./AdvisorPortal.png'),
  pronouns: require('./pronouns.png'),
  gender: require('./gender.png'),
  advisorCategory: require('./advisorCategory.png'),
  advisorEthnicity: require('./advisorEthnicity.png'),
  advisorRace: require('./advisorRace.png'),
  advisorDescription: require('./advisorDescription.png'),
  AdvisorStates: require('./AdvisorStates.png'),
  advisorCommunity: require('./advisorCommunity.png'),
  AdvisorDesignitaion: require('./AdvisorDesignitaion.png'),
  avatarPlaceholder: require('./avatarPlaceholder.png'),
  cameraBlueOutline: require('./cameraBlueOutline.png'),
  noNotifications: require('./noNotifications.png'),
  retirementAge: require('./retirementAge.png'),
  financialTopic: require('./financialTopic.png'),
  credit: require('./credit.png'),

  //4th Nov
  ellipse: require('./ellipse.png'),
  dummyUser: require('./dummyUser.png'),

  //2 Dec
  clock: require('./clock.png'),
  impact: require('./impact.png'),
  strategy: require('./strategy.png'),

  //19 Dec
  flag: require('./flag.png'),
  bookMark: require('./bookMark.png'),
  calendar: require('./calendar.png'),
  thumbsUp2: require('./thumbsUp2.png'),

  //24dec
  investing: require('./investing.png'),
  settings2: require('./settings2.png'),
  settingsLucide: require('./settingsLucide.png'),
  //stayintouch: require('./stayintouch.png'),
  financialProfile: require('./financialProfile.png'),
  financialsnapshot2: require('./financialsnapshot2.png'),

  //8 Jam
  bank: require('./bank.png'),
  delete: require('./delete.png'),
  deletex3: require('./deletex3.png'),
  filterIcon: require('./filterIcon.png'),
  microphone: require('./microphone.png'),
  linkAccount: require('./linkAccount.png'),
  VideoCalling: require('./VideoCalling.png'),

  //15 jan
  userRole: require('./userRole.png'),
  advisorRole: require('./advisorRole.png'),
  personalInfo: require('./personalInfo.png'),
  onBoardingTwo: require('./onBoardingTwo.png'),
  AboutYourSelf: require('./AboutYourSelf.png'),

  authApple: require('./auth_apple.png'),
  authGoogle: require('./auth_google.png'),
  authMicrosoft: require('./auth_microsoft.png'),
}
